import React, { createContext, useState, useEffect, useContext } from "react";
import makeApi, { URLS } from "../Utils/apiURL";
import JumpBallLoader from "Components/common/JumpBallLoader";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const config = {
          url: URLS.whiteLableConfig,
          method: "GET"
        };
        let response = await makeApi(config);
        const themeName = response?.data?.theme || "default";
        setTheme(themeName);
      } catch (err) {
        console.error("Failed to fetch theme config:", err);
        setTheme("default");
      }
    };

    fetchTheme();
  }, []);

  useEffect(() => {
    if (theme) {
      document.body.classList.remove(...document.body.classList);
      document.body.classList.add(`theme-${theme}`);
      setLoading(false);
    }
  }, [theme]);

  if (loading) {
    return <JumpBallLoader />;
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
